import { render, staticRenderFns } from "./accounts_collection_detail_bill.vue?vue&type=template&id=ac6a0806"
import script from "./accounts_collection_detail_bill.vue?vue&type=script&lang=js"
export * from "./accounts_collection_detail_bill.vue?vue&type=script&lang=js"
import style0 from "./accounts_collection_detail_bill.vue?vue&type=style&index=0&id=ac6a0806&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports